<template>
  <div>
    <section class=" container section is-main-section">
      <form @submit.prevent="save">
        <div>
            <v-card-component title="Edit Vehicle Maintenance Details" icon="mdi-bus">
               <v-card-actions>
        <router-link :to="{ name: 'vehicleMaintenance' }">
          <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top> <v-icon left>mdi-arrow-left</v-icon>back</v-btn>
          <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10" style="opacity:.6;"> <v-icon>mdi-arrow-left</v-icon></v-btn>
        </router-link>
      </v-card-actions>
<v-row>
<v-col>
     <v-row>
      <v-col cols="12" lg="3" sm="6">
        <span class="body-2 font-weight-medium">Type</span>
        <span class="error--text ml-1">*</span>
        <v-autocomplete v-model="Type" key="id" class="my-0 py-1" required  single-line placeholder="---Select---" :items="Types" item-text="name" item-value="value">
        </v-autocomplete>
      </v-col>
        <v-col cols="12" lg="3" sm="6">
        <span class="body-2 font-weight-medium"> Meter Reading  <span class="error--text ml-1">*</span></span>
        <v-text-field v-model.trim="meterReading" required class="my-0 py-1" type="number">
        </v-text-field>
      </v-col>
        <v-col cols="12" lg="3" sm="6">
        <span class="body-2 font-weight-medium"> Vendor/Supplier Name <span class="error--text ml-1">*</span></span>
        <v-text-field v-model.trim="vendorsupplierName" required class="my-0 py-1" type="text">
        </v-text-field>
      </v-col>
       <v-col cols="12" lg="3" sm="6">
        <span class="body-2 font-weight-medium"> Bill No / Invoice Number <span class="error--text ml-1">*</span></span>
        <v-text-field v-model.trim="billInvoiceNumber" required class="my-0 py-1">
        </v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" lg="3" sm="6">
        <span class="body-2 font-weight-medium"> Cost  <span class="error--text ml-1">*</span></span>
        <v-text-field v-model.trim="cost" step="any" required class="my-0 py-1" type="number">
        </v-text-field>
      </v-col>
      <v-col cols="12" lg="3" md="6">
              <label class="body-2 font-weight-medium"> Service Start Date <span class="error--text">*</span></label>
              <custom-date-picker v-model="serviceStartdate" required />
            </v-col>
           <v-col cols="12" lg="3" sm="6">
        <span class="body-2 font-weight-medium"> Remark </span>
        <v-text-field v-model.trim="remark" class="my-0 py-1">
        </v-text-field>
      </v-col>
      </v-row>
</v-col>
</v-row>
 <div class="columns form-row">
            <div class="column">
              <div class="field">
                <label class="label">
                  Upload Vehicle Maintenance Details
                </label>
                <b-field class="file is-primary">
                  <b-upload @input="onFilechange()" v-model="dropFile" multiple class="file-label">
                    <span class="file-cta">
                      <b-icon class="file-icon" icon="upload"></b-icon>
                      <span class="file-label">Click to upload</span>
                    </span>
                  </b-upload>
                </b-field>
                <span class="has-text-danger">Allowed files:  .png, .jpg, .jpeg, .pdf </span>
<br/><br/> <span class="has-text-danger">File's that are not supported will be removed automatically!</span>
                <span v-if="dropFile.length > 0">
                  <div class="tags" v-for="(file, i) in dropFile" :key="i">
                    <span class="tag is-primary">
                      {{ file.name }}
                    </span>
                    <button class="delete is-small" type="button" @click="deleteDropFile(i)"></button>
                  </div>
                </span>
              </div>
            </div>
            <button class="button is-success" :disabled="hasClicked" type="submit" style="margin-top:20px;margin-right:100px;">Save</button>
          </div>
          <span v-if="dropFile1.length > 0">
        <span style="margin-top:50px;" class="has-text-primary">Already Uploaded Documents</span>
                    <div  class="tags" v-for="(file, i) in dropFile1" :key="i">
                     <div @click="download(file.urlPath)" class="tag is-primary">
                        {{ file.name }}
                      </div>

                      <button class="delete is-small" type="button"
                        @click="deleteDropFile1(file.id)"></button>
                    </div>
                  </span>
  </v-card-component>
        </div>
        <div></div>
      </form>
    </section>
  </div>
</template>
<script>
import constants from '@/utils/constants'
import Utils from '@/utils'
import moment from 'moment'
import VCardComponent from '@/components/template/VCardComponent'
import CustomDatePicker from '@/components/template/CustomDatePicker'
export default {
  name: 'editVehicleMaintenance',
  props: ['maintenanceID'],
  components: {
    VCardComponent,
    CustomDatePicker
  },
  data () {
    return {
      total: 0,
      dropFile: [],
      vehicleID: '',
      Type: '',
      meterReading: null,
      readingRequired: '',
      nextServiceMeterReading: null,
      vendorsupplierName: '',
      billInvoiceNumber: '',
      cost: null,
      remark: '',
      serviceStartdate: '',
      isRequired: false,
      serviceExpirydate: '',
      vehicleMaintenancDocumentData: [],
      vehicleMaintenanceData: [],
      dropFile1: [],
      deleteFileIdArr: [],
      title: '',
      hasClicked: false,
      loader: true,
      isWrite: false,
      Types: [
        { id: 1, name: 'Battery Condition ChangedOn', value: 'Battery Condition ChangedOn' },
        { id: 2, name: 'Engine Oil', value: 'Engine Oil' },
        { id: 3, name: 'Gear Oil', value: 'Gear Oil' },
        { id: 4, name: 'Break Fule Oil', value: 'Break Fule Oil' },
        { id: 5, name: 'Tyre Repair', value: 'Tyre Repair' },
        { id: 6, name: 'Hubs', value: 'Hubs' },
        { id: 7, name: 'Vehicle Service', value: 'Vehicle Service' },
        { id: 8, name: 'Spare Parts', value: 'Spare Parts' },
        { id: 9, name: 'AC Repair', value: 'AC Repair' },
        { id: 10, name: 'SLD/ECU', value: 'SLD/ECUr' }
      ],
      allowedFiles: [
        'png', 'jpg', 'jpeg', 'pdf'
      ]
    }
  },

  async created () {
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
    await this.vehicleMaintenanceDetails()
    await this.vehicleMaintenanceDocuments()
  },
  methods: {
    vehicleMaintenanceDetails: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const { data } = await http.get(`${constants.API_URL}/api/transport/vehicledetails/vehiclemaintainancedetails/${this.maintenanceID}`)
        this.vehicleMaintenanceData = data
        this.Type = this.vehicleMaintenanceData.type
        this.meterReading = this.vehicleMaintenanceData.meterReading
        this.readingRequired = this.vehicleMaintenanceData.meterReadingRequired
        this.nextServiceMeterReading = this.vehicleMaintenanceData.nextSrviceMeterReading
        this.vendorsupplierName = this.vehicleMaintenanceData.vendorSupplierName
        this.billInvoiceNumber = this.vehicleMaintenanceData.billNo
        this.cost = this.vehicleMaintenanceData.cost
        this.remark = this.vehicleMaintenanceData.remark
        this.serviceStartdate = moment(this.vehicleMaintenanceData.serviceDate, 'YYYY-MM-DD').format('YYYY-MM-DD')
        this.serviceExpirydate = moment(this.vehicleMaintenanceData.nextSceduleDate, 'YYYY-MM-DD').format('YYYY-MM-DD')
        this.repairApprovedBy = this.vehicleMaintenanceData.repairApprovedBy
        this.loadingComponent.close()
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    vehicleMaintenanceDocuments: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const { data } = await http.get(`${constants.API_URL}/api/transport/vehicledetails/vehiclemaintainancedetails/${this.maintenanceID}`)
        this.vehicleMaintenancDocumentData = data
        this.dropFile1 = this.vehicleMaintenancDocumentData.vehicleDocumentsMaps
        if (this.dropFile1) {
          this.dropFile1.forEach(docID => {
            docID.name = docID.urlKey.substring(docID.urlKey.lastIndexOf('/') + 1)
          })
        }
        this.loadingComponent.close()
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    download: async function (i) {
      try {
        let url = await http.get(`${constants.API_URL}/api/staff/downloadurl?s3urlKey=${i}`)
        window.open(url.data)
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting file details, ${errorMessage}`)
      }
    },
    deleteDropFile (i) {
      this.dropFile.splice(i, 1)
    },
    deleteDropFile1 (docID) {
      this.$buefy.dialog.confirm({
        title: 'Deleting Image',
        message: '"Do you want to Delete this file"?',
        confirmText: 'Delete Image',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.dropFile1.forEach(element => {
            if (docID === element.id) {
              var index = this.dropFile1.indexOf(element)
              if (index !== -1) {
                this.dropFile1.splice(index, 1)
              }
              this.deleteFileIdArr.push(docID)
            }
          })
        }
      })
    },
    save: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        if (this.deleteFileIdArr.length > 0) {
          this.deleteFileIdArr.forEach(docID => {
            this.deleteDocument(docID)
          })
        }
        let formData = new FormData()
        formData.append('Type', this.Type)
        formData.append('meterReading', this.meterReading)
        formData.append('vendorSupplierName', this.vendorsupplierName)
        formData.append('billNo', this.billInvoiceNumber)
        formData.append('cost', this.cost)
        formData.append('remark', this.remark)
        formData.append('serviceDate', this.serviceStartdate)
        for (let i = 0; i < this.dropFile.length; i++) {
          formData.append('vehicleMaintainanceAttachements', this.dropFile[i])
        }
        // for (var pair of formData.entries()) {
        //   console.log(pair)
        // }
        this.hasClicked = true
        await http.put(`${constants.API_URL}/api/transport/vehicledetails/vehiclemaintainancedetails/${this.maintenanceID}`, formData)
        this.loader = false
        this.loadingComponent.close()
        this.$router.push({ name: 'vehicleMaintenance' })
        return this.$buefy.dialog.alert({
          type: 'is-success',
          message: 'Saved successfully',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While Details', errorMessage)
        this.lock = false
        this.hasClicked = false
        this.loader = false
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    onFilechange () {
      let r = this.dropFile.filter((a, i) => {
        if (this.allowedFiles.includes(a.name.split('.').pop())) {
        }
        return this.allowedFiles.includes(a.name.split('.').pop())
      })
      this.dropFile = r
    },
    deleteDocument: async function (deldocID) {
      try {
        await http.get(`${constants.API_URL}/api/transport/vehicledetails/vehiclemaintainancedetails/status/${deldocID}`)
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    clear () {
      if (this.readingRequired !== 'YES') {
        this.nextServiceMeterReading = ''
        this.serviceExpirydate = ''
      } else {
        this.isRequired = true
      }
    }
  }
}
</script>
